import React, {
  useMemo,
} from 'react';
import PropTypes from 'prop-types';

export default function ColorSizeText({ product }) {
  const output = useMemo(() => {
    const colorText = product.color || product.swatch;
    const sizeText = product.size || product.sizePrimary;

    let outputText = colorText || '';

    if (colorText && sizeText) outputText += ', ';

    if (sizeText) { outputText += sizeText; }

    return (
      <span className="color-size-text">
        {outputText.toLowerCase()}
        <span>{product.sizeSecondary ? ` X ${product.sizeSecondary}`.toLowerCase() : ''}</span>
      </span>
    );
  }, [product]);

  return output;
}

ColorSizeText.propTypes = {
  product: PropTypes.shape({
    swatch: PropTypes.string,
    sizePrimary: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
  }).isRequired,
};
